import axios from "axios";
import auth from "./auth";

// Needed so the browser stores/sends the new-device tracking cookie set by auth/login and auth/generate-device-id
axios.defaults.withCredentials = true;

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    console.error("An unexpected error occured.");
  }

  return Promise.reject(error);
});

axios.interceptors.request.use(
  function (config) {
    const token = auth.getJWT();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};
